import AsyncStorage from '@react-native-async-storage/async-storage';
import { supabase } from './supabase';
import { capturerIncident } from './sentry';

const LAST_PING_KEY = 'lastSessionPing';

// Jour courant en UTC (YYYY-MM-DD), aligné sur active_date côté SQL.
export function utcToday(): string {
  return new Date().toISOString().slice(0, 10);
}

// Un seul incident par lancement de l'app : chaque retour au premier plan retente, et un refus
// persistant ne doit pas devenir un bruit par ouverture.
let dejaSignale = false;

export function reinitialiserSignalement(): void {
  dejaSignale = false;
}

function signaler(code: string): void {
  if (dejaSignale) return;
  dejaSignale = true;
  capturerIncident(code, 'config');
}

// Enregistre l'ouverture du jour. Dédup native par PK (user_id, active_date) → upsert ignore-duplicates.
// user_id vient du default auth.uid() côté DB. Rend false si le serveur refuse : supabase-js ne lève
// pas sur un 403, il rend { error } — l'ignorer faisait passer un refus RLS pour un succès.
export async function pingSession(activeDate: string): Promise<boolean> {
  const { error } = await supabase
    .from('app_sessions')
    .upsert({ active_date: activeDate }, { onConflict: 'user_id,active_date', ignoreDuplicates: true });
  if (error) {
    signaler(`app_sessions_refus_${error.code || 'inconnu'}`);
    return false;
  }
  return true;
}

// Débounce 1/jour : n'appelle le réseau que si la date a changé depuis le dernier ping (AsyncStorage).
// La date n'est mémorisée qu'après un succès, sinon un refus bloquerait le réessai jusqu'au lendemain.
export async function recordSessionOnce(): Promise<void> {
  try {
    const today = utcToday();
    const last = await AsyncStorage.getItem(LAST_PING_KEY);
    if (last === today) return;
    if (!(await pingSession(today))) return;
    await AsyncStorage.setItem(LAST_PING_KEY, today);
  } catch {
    // télémétrie best-effort : un échec ne doit jamais perturber l'app, mais il se signale.
    signaler('app_sessions_ping_leve');
  }
}
